import Component from './RecordsCellRenderer.component';

export default Component;
